
import { Link } from 'react-router-dom';

export default function Home() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center px-4">
      <div className="max-w-4xl w-full text-center">
        <h1 className="text-4xl font-bold text-gray-800 mb-8">動画シミュレーション</h1>
        <p className="text-lg text-gray-600 mb-12">シミュレーション動画を選択してください</p>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 max-w-2xl mx-auto">
          <Link 
            to="/simulation1" 
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-200"
          >
            <div className="text-2xl font-semibold text-blue-600 mb-2">シミュレーション①</div>
            <p className="text-gray-600">最初のシミュレーション動画</p>
          </Link>
          
          <Link 
            to="/simulation2" 
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-200"
          >
            <div className="text-2xl font-semibold text-blue-600 mb-2">シミュレーション②</div>
            <p className="text-gray-600">2番目のシミュレーション動画</p>
          </Link>
          
          <Link 
            to="/simulation3" 
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-200"
          >
            <div className="text-2xl font-semibold text-blue-600 mb-2">シミュレーション③</div>
            <p className="text-gray-600">3番目のシミュレーション動画</p>
          </Link>
          
          <Link 
            to="/simulation4" 
            className="bg-white p-6 rounded-lg shadow-md hover:shadow-lg transition-shadow duration-300 border border-gray-200"
          >
            <div className="text-2xl font-semibold text-blue-600 mb-2">シミュレーション④</div>
            <p className="text-gray-600">4番目のシミュレーション動画</p>
          </Link>
        </div>
      </div>
    </div>
  );
}
